module.exports = __webpack_public_path__ + "static/media/close.d9604bfc.png";